import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_37: FaireProductEntity = {
  token: "legacy_prod_abbott-37",
  type: "product",
  name: 'All Purpose Scissors Red 8" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8a718cc512174daeaf85659d3b73e9963be16af6f59961ad4dc5d428dc36eef4.jpeg",
  priceDollars: 6,
  msrpDollars: 12,
  subcategory: "Scissors & Tools",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
